import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'

import { Typography } from '@s4l/ds'
import { type UtilityClasses } from '@s4l/utility-css'
import CheckItem from './CheckItem'
import RequestButton from './RequestButton'
import StatusBadge from './StatusBadge'

import { type InvoicePanelProps, INVOICE_STATUS } from './types'
import styles from './index.module.css'

const InvoicePanel: React.FC<InvoicePanelProps> = ({
  status = INVOICE_STATUS.DEFAULT,
  date,
  hash,
}) => {
  const intl = useIntl()
  const [invoice, setInvoice] = React.useState({
    date,
    status,
  })

  useEffect(() => {
    setInvoice({
      date,
      status,
    })
  }, [date, status])

  const handleFormSubmit = () => {
    setInvoice({
      status: INVOICE_STATUS.REQUESTED,
      date: new Date().toISOString(),
    })
  }

  return (
    <div className={styles.container}>
      <Typography variant="title" size="xs" as="h3" className={styles.title as UtilityClasses}>
        {intl.formatMessage({
          id: 'global.request-invoice',
        })}
      </Typography>

      {invoice.status !== INVOICE_STATUS.DEFAULT && (
        <StatusBadge type={invoice.status} date={invoice.date} />
      )}

      {invoice.status === INVOICE_STATUS.DEFAULT && (
        <CheckItem
          text={intl.formatMessage({
            id: 'invoice.info-request',
          })}
        />
      )}

      {invoice.status !== INVOICE_STATUS.NOT_AVAILABLE && (
        <CheckItem
          text={intl.formatMessage({
            id: 'invoice.sent-by-email',
          })}
        />
      )}

      {invoice.status === INVOICE_STATUS.DEFAULT && (
        <RequestButton hash={hash} onSubmit={handleFormSubmit} />
      )}

      {invoice.status === INVOICE_STATUS.NOT_AVAILABLE && (
        <CheckItem
          text={intl.formatMessage({
            id: 'invoice.booking',
          })}
        />
      )}
    </div>
  )
}

export default InvoicePanel
